const styles = (theme, props) => {
  return {
    root: {
      padding: 0,
      textAlign: 'center',
    },
  };
};

export default styles;
